import { createPinia, Pinia } from "pinia";

export function initPinia()
{
    if (!pinia)
        pinia = createPinia();
    return pinia;
}
let pinia: Pinia;